import Header from "../../components/header/Header";
import React, { useEffect, useState } from "react";
import { SearchIcon, X } from "lucide-react";
import { Button, Card, Modal } from "@mui/material";
import TableClients from "../../components/TableClients";
import { SquareUser } from 'lucide-react';
import FormClient from "./formClient";
import SearchBar from './../../components/Searchbar';
import axios from "axios";
import api from "../../services/api";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MonitoringDownloadXml from "../../components/MonitoringDownloadXml";
export default function Clients() {
    //valor de pesquisa
    const [search, setSearch] = useState('')
    //controla o modal
    const [open, setOpen] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)


    //campos do formulario de clientes
    const [name, setName] = useState('')
    const [adress, setAdress] = useState('')
    const [district, setDistrict] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [cep, setCep] = useState('')
    const [phone, setPhone] = useState('')
    const [cnpj, setCnpj] = useState('')
    const [selected, setSelected] = useState('')
    //armazena a lista de clientes
    const [clientsList, setClientsList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [loading, setLoading] = useState(false)

    //sempre que um cliente for adicionado a pagina e reccaregada
    const [reload, setReload] = useState(false)

    async function getClients() {
        setLoading(true)
        await axios.get(`${api}cliente`)
            .then((res) => {
                setClientsList(res.data)
                setFilteredList(res.data)

                setLoading(false)
            })
            .catch((error) => {
                toast.error('Erro ao buscar os clientes')
            })
    }

    useEffect(() => {
        getClients()

    }, [])

    useEffect(() => {
        getClients()
    }, [reload])

    //verifica se o termo pesquisado e um numero
    function isNumber(value) {
        return /^\d+$/.test(value)

    }
    async function SearchClient() {
        if (search !== '') {
            if (isNumber(search)) {
                SearchByCnpj()
            } else {
                SearchByName()
            }

        } else {
            toast.warn('É necessário um valor de busca')
        }

    }
    function SearchByName() {
        setLoading(true)
        const filter = clientsList.filter((item) => item.NOME.includes(search.toUpperCase()))
        if (filter.length > 0) {
            setFilteredList(filter)
            setLoading(false)
        } else {
            setFilteredList([])
            toast.warn('Nenhum cliente encontrado!')
            setLoading(false)
        }
    }
    function SearchByCnpj() {
        setLoading(true)
        const filter = clientsList.filter((item) => item.CNPJ.includes(search))
        if (filter.length > 0) {
            setFilteredList(filter)
            setLoading(false)
        } else {
            setFilteredList([])
            toast.warn('Nenhum cliente encontrado!')
            setLoading(false)
        }
    }


    // se o searcg for vazio ele seta a lista com  os dados originais
    useEffect(() => {
        if (search === '') {
            setFilteredList(clientsList)
        }

    }, [search])




    //função para deletar um cliente
    async function DeleteClient() {
        setOpenConfirm(false)
        setLoading(true)
        await axios.delete(`${api}cliente/${selected.CODIGO}`)
            .then((res) => {
                toast.success('Cliente deletado com sucesso')
                setLoading(false)
                setReload(!reload)
            }).catch((error) => {
                toast.error('Erro ao deletar cliente',
                    error.message
                )
                setLoading(false)
                setReload(!reload)
            })
    }

    return (
        <div className="flex h-[100vh] w-[100vw] overflow-hidden ">
            <Header />

            <div className='mx-8 my-8 max-md:mt-14'>
                <p className="font-semibold my-2">Clientes</p>
                {/**Searchbar */}
                <div className="flex gap-1 max-md:grid grid-cols-1">
                    <SearchBar
                        search={search}
                        setSearch={setSearch}
                        placeholder='Buscar clientes por nome ou CNPJ'
                        onClick={SearchClient}
                    />


                    {
                        /**botao para adicionar novo cliente */
                    }
                    <button className='mx-12 bg-orange-500 text-white px-4 rounded-md text-sm
                    hover:bg-orange-300 max-w-[12rem]
                    '
                        onClick={() => {
                            setSelected('')
                            setName('')
                            setCnpj('')
                            setPhone('')
                            setAdress('')
                            setDistrict('')
                            setCep('')
                            setCity('')
                            setState('')
                            setOpen(true)
                        }}
                    >
                        Adicionar cliente
                    </button>




                </div>
                {/**Lista de clientes */}




                {
                    loading ?
                        <div className='absolute left-[50%] top-[50%]'>
                            <CircularProgress color='warning' />
                        </div>

                        :


                        < TableClients data={filteredList} type='clients'
                            setSelected={setSelected}
                            open={open}
                            setOpen={setOpen}
                            DeleteClient={setOpenConfirm}
                        />


                }




            </div>

            <Modal
                className="flex justify-center items-center"
                open={open}

            >
                <FormClient setOpen={setOpen}
                    name={name}
                    setName={setName}
                    cnpj={cnpj}
                    setCnpj={setCnpj}
                    adress={adress}
                    setAdress={setAdress}
                    district={district}
                    setDistrict={setDistrict}
                    phone={phone}
                    setPhone={setPhone}
                    city={city}
                    setCity={setCity}
                    setState={setState}
                    state={state}
                    cep={cep}
                    setCep={setCep}
                    selected={selected}
                    setReload={setReload}
                    reload={reload}

                />
            </Modal>


            <Dialog
                open={openConfirm}

                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Tem certeza que deseja deletar este cliente?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Você está prestes a deletar o cliente {selected.NOME}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)}>CANCELAR</Button>
                    <Button onClick={DeleteClient} >
                        CONFIRMAR
                    </Button>
                </DialogActions>
            </Dialog>
            <MonitoringDownloadXml/>
        </div>

    )
}